import { useEffect } from 'react';

// Closes a popover (bell, account menu, "⋯" menus) on a tap or click outside it.
// `inside` is a CSS selector or a ref to the popover's wrapper. That first tap only
// closes: the click it would make on whatever is underneath is swallowed. Escape
// closes it too.
export default function useOutsideClose(inside, open, close) {
  useEffect(() => {
    if (!open) return;
    const isInside = el => (typeof inside === 'string' ? !!el.closest?.(inside) : !!inside.current?.contains(el));
    const swallow = e => { e.stopPropagation(); e.preventDefault(); };
    const onDown = e => {
      if (isInside(e.target)) return;
      close();
      document.addEventListener('click', swallow, { capture: true, once: true });
      setTimeout(() => document.removeEventListener('click', swallow, { capture: true }), 700);
    };
    const onKey = e => { if (e.key === 'Escape') close(); };
    document.addEventListener('pointerdown', onDown, true);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('pointerdown', onDown, true);
      document.removeEventListener('keydown', onKey);
    };
  }, [inside, open, close]);
}
